<template>
	<div class="summary custom-scrollbar" :class="{ summary__short: isAdmin }">
		<div class="summary__content" v-if="!loadingUser">
			<div class="summary__header">
				<h5 class="summary__h5">Quick overview</h5>
				<button class="summary__close" @click="requestClose">
					<i class="fa-solid fa-xmark"></i>
				</button>
			</div>
			<div class="summary__body">
				<div class="summary__title">{{ summaryArticle.title }}</div>
				<div class="summary__aliases" v-if="summaryArticle.aliases">
					<p>{{summaryArticle.aliases.join(', ')}}</p>
				</div>
				<div class="summary__description">{{ cleanDesc }}</div>
			</div>
			<router-link
				class="hyper-click-primary text-decoration-none"
				:to="'/article-view?id=' + summaryArticle.id"
			>
				<span class="hyper-label">
					View details
					<i class="fa-solid fa-arrow-up-right-from-square"></i>
				</span>
			</router-link>
		</div>
		<div class="summary__spinner" v-if="loadingUser">
			<Spinner />
		</div>
	</div>
</template>

<script>
import Article from "../../../services/article";
import Spinner from "../../shared/Spinner";

export default {
	name: "SideSummaryPanel",
	components: {
		Spinner,
	},
	props: ["summaryArticleId", "isAdmin"],
	data: function () {
		return {
			summaryArticle: {},
			loadingUser: false,
		};
	},
	mounted() {
		this.getArticleResume();
	},
	methods: {
		requestClose: function () {
			let query = this.$route.query;
			let path = this.$route.path;
			this.$router.push({
				path: path,
				query: { ...query, resume: undefined },
			});
		},
		getArticleResume: function () {
			this.loadingUser = true;
			Article.instance()
				.getArticleResume(this.summaryArticleId)
				.then((res) => {
					this.summaryArticle = res.data;
					this.loadingUser = false;
				})
				.catch((err) => {
					console.error(err);
					this.loadingUser = false;
				});
		},
		truncText: (text, length) => {
			if (!text) return "";
			let trim;
			if (text.length > length) {
				trim = text.substr(0, length);
				trim = trim.substr(
					0,
					Math.min(trim.length, trim.lastIndexOf(" "))
				);
				trim = trim + "...";
			} else {
				trim = text;
			}
			return trim;
		},
	},
	computed: {
		cleanDesc: function () {
			if (!this.summaryArticle || !this.summaryArticle.description) {
				return "";
			}
			let text = this.summaryArticle.description.replace(
				/<\/?[^>]+(>|$)/g,
				""
			);
			return this.truncText(text, 750);
		},
	},
	watch: {
		summaryArticleId: function () {
			if (this.summaryArticleId) {
				this.getArticleResume();
			}
		},
	},
};
</script>

<style scoped>
.summary {
	padding: 2.5rem;
	height: calc(100vh - 58px - 42px);
	overflow: auto;
}

.summary__short {
	height: calc(100vh - 58px - 42px - 300px);
}

.summary__header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 3rem;
}

.summary__h5 {
	color: var(--textTertiary);
}

.summary__close {
	background-color: transparent;
	border: none;
	width: 30px;
	height: 24px;
	color: var(--clr-accent-primary);
}

.summary__title {
	color: var(--textPrimary);
	font-weight: bold;
	margin-bottom: 1rem;
}
.summary__description {
	color: var(--textPrimary);
	margin-bottom: 1rem;
	word-break: break-word;
}

.summary__aliases p {
	color: var(--textTertiary);
}

</style>